// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { Menu, MenuItem, Submenu } from 'element-ui';
import $ from 'jquery'

import 'element-ui/lib/theme-chalk/index.css';
import '../src/css/bootstrap.css'
import '../src/css/chocolat.css'
import '../src/css/font-awesome.css'
import '../src/css/style.css'

import '../src/js/jquery.chocolat'
import '../src/js/bootstrap-3.1.1.min'
import '../src/js/easing'

import '../src/js/move-top'
import '../src/js/responsiveslides.min'
// import BaiduMap from 'vue-baidu-map'
//
// Vue.use(BaiduMap, {
//   ak: 'Gbnhd8Q9XtedQAq0Rq9xHdXGGHEj4hV7'
// });

Vue.config.productionTip = false
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, $,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js